import { defineComponent as _defineComponent } from 'vue';
import { SIcon, SImageLazy } from '@strana-artw/ui-kit';
import { storeToRefs } from 'pinia';
import { defineComponent, toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { NavButton as HeaderButton } from '@/shared/ui';
import { useAuthStore } from '@/store/authStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyButton',
  props: {
    isShowMobile: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'LoyaltyButton'
    });
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      user = _storeToRefs.user;
    var _toRefs = toRefs(useScreenPlugin()),
      isDesktop = _toRefs.isDesktop;
    return {
      __sfc: true,
      authStore: authStore,
      user: user,
      isDesktop: isDesktop,
      SIcon: SIcon,
      SImageLazy: SImageLazy,
      HeaderButton: HeaderButton
    };
  }
});